import PropTypes from 'prop-types';

export const BackgroundFill = {
  primaryFill: PropTypes.string,
  secondaryFill: PropTypes.string,
};

export const BackgroundType = {
  type: PropTypes.oneOf(['swoop', 'angle']).isRequired,
};

export const ParentDimensions = {
  bottom: PropTypes.number,
  height: PropTypes.number,
  left: PropTypes.number,
  right: PropTypes.number,
  top: PropTypes.number,
  width: PropTypes.number,
  x: PropTypes.number,
  y: PropTypes.number,
};
